import { useContext } from "react";
import { ControlLayoutContext } from "@plansoft-configuration-renderer/layout";
/**
 * Get control props from layout for info control
 * @returns
 */
export function useInfoControlLayoutProps() {
    const { textMode = "markdown" } = useContext(ControlLayoutContext);
    return { textMode };
}
//# sourceMappingURL=useInfoControlLayoutProps.js.map